import { Disposable } from '@gitlab-org/disposable';
import { Transport } from '@gitlab-org/webview-transport';
import { WebviewAddress } from '@gitlab-org/webview-plugin';
import { WebviewRuntimeMessageBus } from '../../../events';
import { ManagedInstances } from './event_filters';

export const setupTransportEventHandlers = (
  transport: Transport,
  runtimeMessageBus: WebviewRuntimeMessageBus,
  managedInstances: ManagedInstances,
): Disposable[] => [
  transport.on('webview_instance_created', (address: WebviewAddress) => {
    managedInstances.add(address.webviewInstanceId);
    runtimeMessageBus.publish('webview:connect', address);
  }),
  transport.on('webview_instance_destroyed', (address: WebviewAddress) => {
    managedInstances.delete(address.webviewInstanceId);
    runtimeMessageBus.publish('webview:disconnect', address);
  }),
  transport.on('webview_instance_notification_received', (message) =>
    runtimeMessageBus.publish('webview:notification', message),
  ),
  transport.on('webview_instance_request_received', (message) =>
    runtimeMessageBus.publish('webview:request', message),
  ),
  transport.on('webview_instance_response_received', (message) =>
    runtimeMessageBus.publish('webview:response', message),
  ),
];
